"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var RoleNameInput_vue_1 = __importDefault(require("../form/RoleNameInput.vue"));
var VButton_vue_1 = __importDefault(require("../scraps/VButton.vue"));
var VModal_vue_1 = __importDefault(require("../scraps/VModal.vue"));
var CreateDistrictModal_vue_1 = __importDefault(require("./CreateDistrictModal.vue"));
var event_bus_1 = require("../../event-bus");
exports.default = vue_1.default.extend({
    name: "create-district",
    components: {
        CreateDistrictModal: CreateDistrictModal_vue_1.default,
        RoleNameInput: RoleNameInput_vue_1.default,
        VButton: VButton_vue_1.default,
        VModal: VModal_vue_1.default
    },
    data: function () {
        return {
            showModal: false
        };
    },
    methods: {
        onDistrictCreate: function (name) {
            this.showModal = false;
            event_bus_1.EventBus.$emit(event_bus_1.events.district.create, {
                name: name
            });
        }
    }
});
